import { useCallback } from 'react';
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
import { Accounting } from '~/types/api.model';
import { applyAccountingMapping } from './useApplyAccountingMapping.utils';
export const useApplyAccountingMapping = ()=>{
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    const isLinkedToQbo = useStore(selectors.integration.isLinkedToQbo);
    const isLinkedToXero = useStore(selectors.integration.isLinkedToXero);
    const { t: texts } = useLocaleKeys('components.manageContactModalForVendor');
    const { t: errorTexts } = useLocaleKeys('errors');
    return useCallback(function(contactId, contactVersion, selectedOption) {
        let currentIntegratedIds = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        const selections = [];
        if (isLinkedToQbo) {
            selections.push({
                accounting: Accounting.QBO,
                option: selectedOption.qbo,
                currentIntegratedId: currentIntegratedIds.qbo
            });
        }
        if (isLinkedToXero) {
            selections.push({
                accounting: Accounting.Xero,
                option: selectedOption.xero,
                currentIntegratedId: currentIntegratedIds.xero
            });
        }
        return applyAccountingMapping({
            contactId,
            contactVersion,
            selections,
            createContact: api.accounting.createContact,
            linkContact: api.accounting.linkContact,
            showErrorToast: overlayContext.showErrorToast,
            texts,
            errorTexts
        });
    }, [
        api,
        overlayContext,
        isLinkedToQbo,
        isLinkedToXero
    ]);
};
